module.exports = __webpack_public_path__ + "img/8-2.32f345c7.jpg";